import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getDatabase } from "firebase/database";
import { getStorage } from "firebase/storage";
import { getAnalytics } from "firebase/analytics";

const firebaseConfigString = process.env.REACT_APP_FIREBASE_WEB_CREDENTIALS;
if (!firebaseConfigString) {
  throw new Error('Firebase configuration is missing. Check your environment variables.');
}

const firebaseConfig = JSON.parse(firebaseConfigString);
// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);
export const auth = getAuth(app);
export const db = getDatabase(app);
export const storage = getStorage(app);
